var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ill: "#E0E0E0",
    stroke: "#E0E0E0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6397_21314)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62565 2.42367C9.77848 2.11399 10.2201 2.11399 10.373 2.42367L12.3515 6.43259C12.4121 6.55557 12.5295 6.6408 12.6652 6.66052L17.0893 7.30338C17.4311 7.35304 17.5675 7.77304 17.3202 8.01409L14.1189 11.1346C14.0207 11.2303 13.9759 11.3683 13.9991 11.5034L14.7548 15.9096C14.8131 16.25 14.4559 16.5096 14.1502 16.3488L10.1932 14.2685C10.0718 14.2047 9.92682 14.2047 9.8054 14.2685L5.84838 16.3488C5.54271 16.5096 5.18544 16.25 5.24382 15.9096L5.99955 11.5034C6.02273 11.3683 5.97792 11.2303 5.87972 11.1346L2.67841 8.01409C2.43111 7.77304 2.56757 7.35304 2.90933 7.30338L7.33343 6.66052C7.46915 6.6408 7.58647 6.55557 7.64716 6.43259L9.62565 2.42367Z",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6397_21314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewStar);
export default __webpack_public_path__ + "static/media/review-star.bca0ad7e90dd085b38443db44308a244.svg";
export { ForwardRef as ReactComponent };